module.exports = __webpack_public_path__ + "static/media/expand.2eb9c4da.svg";